module.exports = __webpack_public_path__ + "img/Gaertnerin-AH-115.9b78fdc0.jpg";